document.addEventListener("DOMContentLoaded", function () {
  const searchBarRoot = document.createElement('div');
  searchBarRoot.id = "search-bar-root";

  // Check for both product and collection pages
  const targetElement = document.querySelector('.main-content') || 
                        document.querySelector('.collection-main-content') ||
                        document.querySelector('.collection-template');

  if (targetElement) {
    targetElement.prepend(searchBarRoot);

    searchBarRoot.innerHTML = `
      <div class="p-4 shadow-md rounded-2xl mb-5">
        <form id="search-form" class="flex items-center gap-2">
          <input
            id="search-input"
            type="text"
            placeholder="Search products..."
            class="w-full border p-2 rounded"
          />
          <button
            type="submit"
            class="px-4 py-2 rounded-xl bg-blue-500 text-white font-semibold"
          >
            Search
          </button>
        </form>
      </div>
    `;

    document.getElementById("search-form").addEventListener("submit", (e) => {
      e.preventDefault();
      const query = document.getElementById("search-input").value;
      if (query) {
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      }
    });
  }
});
